<template>
  <k-data-table v-show="filtered_clip_exports.length" style=""
    :items="filtered_clip_exports"
    hide-actions
    :headers="headers">

    <template slot="items" slot-scope="props">
      <tr>
      <td>
        <k-progress-circular v-if="props.item.status == 'processing'" indeterminate :size="20" :width="2" color="deep-orange"></k-progress-circular>
        <k-icon v-if="props.item.status == 'ready'">done</k-icon>
        <k-icon v-if="props.item.status == 'error'">error</k-icon>
      </td>
      <td>{{props.item.meta.title}}</td>
      <td>{{props.item.meta.destination}}</td>
      <td>{{props.item.date}}</td>
      <td>{{props.item.meta.account}}</td>
      <td class="text-xs-right"><k-btn v-if="$is_admin()" @click="re_export(props.item)" flat fab color="deep-orange" small><k-icon >refresh</k-icon></k-btn></td>
    </tr>
    </template>
  </k-data-table>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
export default {
  props: ['event_uuid'],
  data () {
    var ch = this.$cloudserver.channel("events:clip_exports:"+this.event_uuid);
    return {
      ws_channel: ch,
      headers: [
        {text: "", sortable: false, width: 20},
        {text: "Clip title", sortable: false},
        {text: "Destination", sortable: false},
        {text: "Created", value: "timestamp", sortable: true},
        {text: "Exporter", sortable: false},
        {text: "Actions", sortable: false, align: "right", width: 300}
      ],
      clip_exports: {},
      filtered_clip_exports: []
    }
  },
  created() {
    this.ws_channel.join();
  },
  methods: {
    re_export(item) {
      this.ws_channel.push("re_export_clip", {uuid: item.uuid});
    }
  },
  computed: {
    account () {
      return this.$store.state.account;
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        var self = this;
        console.log(newVal);
        if (typeof(newVal.clip_exports) != "undefined") {
          _.each(newVal.clip_exports, (clip_export) => {
            Vue.set(self.clip_exports, clip_export.uuid, clip_export);
          });
        }
        if (typeof(newVal.clip_export) != "undefined") {
          var clip_export = newVal.clip_export;
          Vue.set(self.clip_exports, clip_export.uuid, clip_export);
        }
        self.filtered_clip_exports = _.filter(_.map(self.clip_exports, (item) => {
  				var m = moment.utc(item.inserted_at);
  				item["timestamp"] = m.unix();
  				item["date"] = m.local().format("L LTS");
  				return item;
  			}), (item) => { return (this.$is_admin() || item.meta.account == this.account.email) && item.timestamp > moment().subtract(7, 'days').unix(); });
      },
      deep: true
    }
  }
}
</script>
